import {Component, OnInit, Inject, NgZone} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KANBAN_TYPE_FACTURATION } from '../../../kanban.model';

@Component({
    selector: 'md-kanban-form-facture-depot-dialog',
    templateUrl: './md-kanban-form-facture-depot-dialog.component.html',
})
export class MdKanbanFormFactureDepotDialogComponent implements OnInit {
    loading = false;
    itemForm = this._formBuilder.group({
        CLIENT: [null, Validators.required],
        TYPE_FACTURATION: [KANBAN_TYPE_FACTURATION.FACTURATION_SPONTANEE],
        NUM_FACTURE: [null, Validators.required],
        MONTANT_FACTURE: [null, Validators.required],
        ZONE: [null]
    });
    kanbanItem: any;
    item?: any;
    startupInfos: any;
    KANBAN_TYPE_FACTURATION = KANBAN_TYPE_FACTURATION;
    filteredClients: any[] = [];
    filteredFactures: any[] = [];
    
    constructor(
        private _formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<MdKanbanFormFactureDepotDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: { kanbanItem: any, startupInfos: any, item?: any },
    ) {
        this.kanbanItem = data.kanbanItem;
        this.startupInfos = data.startupInfos;
        this.item = data.item;
        if (!!data.item) {
            const typeFacturation = data.item.PARAMS_TASK.TYPE_FACTURATION || KANBAN_TYPE_FACTURATION.FACTURATION_SPONTANEE;
            const numFacture = typeFacturation == KANBAN_TYPE_FACTURATION.FACTURATION_MENSUELLE
                ? (data.item.PARAMS_TASK.NUM_FACTURE ? [data.item.PARAMS_TASK.NUM_FACTURE] : [])
                : data.item.PARAMS_TASK.NUM_FACTURE;
            this.itemForm.patchValue({
                CLIENT: data.item.PARAMS_TASK.CLIENT,
                TYPE_FACTURATION: typeFacturation,
                NUM_FACTURE: numFacture,
                MONTANT_FACTURE: data.item.PARAMS_TASK.MONTANT_FACTURE,
                ZONE: data.item.PARAMS_TASK.ZONE,
            });
            this.filteredClients = this.startupInfos.CLIENTS_FACTURES.filter(c => (!c.ZONE && data.item.PARAMS_TASK.ZONE == 'Inconnu') || c.ZONE == data.item.PARAMS_TASK.ZONE);
            this.filteredFactures = this.startupInfos.FACTURES.filter(f => f.NUM_TIERS == data.item.PARAMS_TASK.CLIENT.ID);
        }
    }

    ngOnInit() {
    }

    get f() {
        return this.itemForm.controls;
    }

    dismiss() {
        this.dialogRef.close(false);
    }

    onSubmit(renew: boolean) {
        if (this.itemForm.invalid) { return; }
        const value = this.itemForm.value;
        let data: any[];
        if (value.TYPE_FACTURATION == KANBAN_TYPE_FACTURATION.FACTURATION_MENSUELLE) {
            const selectedFactures = this.startupInfos.FACTURES.filter(f => (value.NUM_FACTURE || []).includes(f.ID));
            data = selectedFactures.map(f => ({
                CLIENT: value.CLIENT,
                TYPE_FACTURATION: value.TYPE_FACTURATION,
                ZONE: value.ZONE,
                NUM_FACTURE: f.ID,
                MONTANT_FACTURE: f.TOTALTTC
            }));
        } else {
            data = [value];
        }
        this.dialogRef.close({ data: data, renew: renew });
    }

    onClientSelected(clientId: any) {
        const client = this.startupInfos.CLIENTS.find(b => b.ID == clientId);
        if (!!client) {
            this.itemForm.controls.CLIENT.patchValue(client);
        }
    }

    onFactureZoneSelected(zone: any) {
        const zoneFacture = this.startupInfos.ZONES_FACTURES.find(z => z.ZONE == zone);
        if (!!zoneFacture) {
            this.itemForm.controls.ZONE.patchValue(zone);
            this.filteredClients = this.startupInfos.CLIENTS_FACTURES.filter(c => (!c.ZONE && zone == 'Inconnu') || c.ZONE == zone);
            this.itemForm.patchValue({
                CLIENT: null,
                NUM_FACTURE: [],
                MONTANT_FACTURE: null
            })
        }
    }

    onFactureClientSelected(numTiers: any) {
        const client = this.startupInfos.CLIENTS_FACTURES.find(b => b.NUM_TIERS == numTiers);
        if (!!client) {
            this.itemForm.controls.CLIENT.patchValue({ ID: client.NUM_TIERS, TEXT: client.LIB_TIERS });
            this.filteredFactures = this.startupInfos.FACTURES.filter(f => f.NUM_TIERS == numTiers);
            this.itemForm.patchValue({
                NUM_FACTURE: [],
                MONTANT_FACTURE: null
            })
        }
    }

    onFactureSelected(numFactures: any[]) {
        const factures = this.startupInfos.FACTURES.filter(f => numFactures.includes(f.ID));
        const montantTotal = factures.reduce((sum, f) => sum + (parseFloat(f.TOTALTTC) || 0), 0);
        this.itemForm.controls.MONTANT_FACTURE.patchValue(factures.length ? montantTotal : null);
    }
}